import React from "react"

import { path } from "~Tutor/TutorRoutes"
import { DescriptionItem, StyledLink } from "~tailwindui/Basics"

import LocalTime from "components/LocalTime"

export type SessionInfoProps = {
  session: {
    startsAt: string
    endsAt: string
    subject: {
      id: string
      name: string
    }
    studyGroup: {
      id: string
      name: string
      details: string
    }
    organization: {
      id: string
      name: string
      details: string
      emailTimeZone: string
    }
  }
}

const SessionInfo: React.FC<SessionInfoProps> = ({ session }) => {
  return (
    <>
      <DescriptionItem
        label="Date"
        value={<LocalTime omitTime timestamp={session.startsAt} />}
      />
      <DescriptionItem
        label="Scheduled Time"
        value={
          <>
            <LocalTime omitDate timestamp={session.startsAt} /> -{" "}
            <LocalTime omitDate timestamp={session.endsAt} />
          </>
        }
      />
      <DescriptionItem label="Subject" value={session.subject?.name} />

      <DescriptionItem
        label="Study Group"
        value={
          session.studyGroup && (
            <div>
              <StyledLink
                to={path("studyGroupDetails", {
                  id: session.studyGroup.id,
                })}
              >
                {session.studyGroup.name}{" "}
              </StyledLink>
            </div>
          )
        }
      />
      {session.studyGroup?.details && (
        <DescriptionItem
          label="Study Group Details"
          value={session.studyGroup.details}
        />
      )}
      {session.organization && (
        <>
          <DescriptionItem
            label="Organization"
            value={session.organization.name}
          />
          {session.organization.details?.length > 0 && (
            <DescriptionItem
              label="Organization Details"
              value={session.organization.details}
            />
          )}
          <DescriptionItem
            label="Organization Time Zone"
            value={session.organization.emailTimeZone}
          />
        </>
      )}
    </>
  )
}

export default SessionInfo
